// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  use_socket: false,
  backend_type: 'PHP',
  url_backend: 'https://coredev.bon-aventure.com',
  max_time_request: 200000,
  syn_records: 5,
  version: '0.5.14',
  url_playstore: 'https://play.google.com/store/apps/details?id=com.bonaventura.n360',
  api_key: 'AIzaSyB_fTAH6-PiMgMU68QQTFQsc7us2SLkilw',
  map_id: '8dae952ff853b5302084d1ff',
  url_n360_socket: 'https://dev360.bon-aventure.com',
  path_n360_socket: '/live'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
